import { useState } from 'react';
import { Container, TextField, Button } from "@mui/material";
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useNavigate } from "react-router-dom";
import BackButton from '../components/BackButton.jsx';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase.js';


// renders the edit dish page for the manager
// allows them to edit a dish on the menu 
function DishM() {
  const { state } = useLocation();
  const { dishInfo } = state;

  const navigate = useNavigate();
  const [name, setName] = useState(dishInfo.name);
  const [price, setPrice] = useState(dishInfo.price);
  const [description, setDescription] = useState(dishInfo.description);
  const [imagePath, setImagePath] = useState(dishInfo.imagePath);

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  // const handleImagePathChange = (event) => {
  //   setImagePath(event.target.value);
  // };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    // Update the dishInfo in the state or send the updated values to the backend
    try {
      const ingredient_ids = dishInfo.ingredients.map(ingredient => ingredient.id)
      const available_extras_ids = dishInfo.available_extras.map(e => e.id);
      console.log(imagePath)
      const body = {
        name,
        imagePath,
        description,
        price,
        ingredients_list: ingredient_ids,
        available_extras_list: available_extras_ids,
        category: dishInfo.category
      }
      const res = await fetch(`/menu/edit_dish/${dishInfo.categoryPosition}/${dishInfo.position}`, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-type': 'application/json',
        }
      })

      // Upload to firebase
      if (editDishImage) {
        const urlCategory = imagePath
        const storageRef = ref(storage, urlCategory);
        try {
          await uploadBytes(storageRef, editDishImage);
          alert('Photo uploaded successfully!');
        } catch (error) {
          console.error('Error uploading file:', error);
          alert('Failed to upload file!');
        }
      }
    } catch (err) {
      console.log(err.message);
    }
    navigate(-1);
  }

  const [editDishImage, setEditDishImage] = useState(null);
  const handleDishEditImageChange = (e) => {
    setEditDishImage(e.target.files[0]);
    setImagePath('images/dishes/' + e.target.files[0].name);
  };

  return (
    <Box sx={{display: 'flex', flexDirection:'column', height: '100%', alignItems: 'center'}}>
      <Box sx={{maxWidth: { sx:1 }, overflowY: 'scroll', height: 4/5}}>
        <BackButton />
        <Container sx={{maxWidth: { sx:1, md: 3/5 }}}>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Name"
              value={name}
              onChange={handleNameChange}
              fullWidth
              margin="normal"
              variant="outlined"
            />
            <TextField
              label="Price"
              value={price}
              onChange={handlePriceChange}
              fullWidth
              margin="normal"
              variant="outlined"
            />
            <TextField
              label="Description"
              value={description}
              onChange={handleDescriptionChange}
              fullWidth
              margin="normal"
              variant="outlined"
            />
            {/* <TextField
              label="ImagePath"
              value={imagePath}
              onChange={handleImagePathChange}
              fullWidth
              margin="normal"
              variant="outlined"
            /> */}
            <input 
              id='image'
              onChange={handleDishEditImageChange}
              type="file"
            />
            <br/>
            <Button type="submit" variant="contained" color="primary" sx={{
                                            mt: '10px',
                                            bgcolor:'black',
                                            color:'white',
                                            mb: '10px',
                                            '&:hover': {
                                              backgroundColor: '#777778',
                                            }
                                          }}>
              Save
            </Button>
          </form>
        </Container>
      </Box>
    </Box>
  );
}

export default DishM;